export default {
	title: "Grupos",
	newGroup: "Nuevo Grupo",
	editGroup: "Editar Grupo",
	deleteGroup: "Eliminar Grupo",
	name: "Nombre",
	description: "Descripción",
	color: "Color",
	icon: "Ícono",
	members: "Miembros",
	calendar: "Calendario",
	assignments: "Actividades",
	addMember: "Agregar Miembro",
	removeMember: "Eliminar Miembro",
	removeMemberConfirm: "¿Está seguro de que desea eliminar este miembro del grupo?",
	deleteConfirm: "¿Está seguro de que desea eliminar el grupo \"{name}\"? Todos los miembros serán desvinculados y todas las actividades y recordatorios serán eliminados. Esta acción no se puede deshacer.",
	noMembers: "No hay miembros en este grupo",
	noMembersText: "Agregue miembros para organizar su grupo",
	noAssignments: "No hay actividades programadas",
	noAssignmentsText: "Agregue una actividad usando el Calendario",
	selectDayHint: "Seleccione un día para ver o agregar una actividad",
	emptyTitle: "No hay grupos registrados",
	emptyText: "Cree grupos para organizar los miembros de su templo",
	searchPlaceholder: "Buscar grupos...",
	status: {
		active: "Activo",
		inactive: "Inactivo",
	},
	filters: {
		status: "Estado",
		active: "Activos",
		inactive: "Inactivos",
	},
	assignment: {
		new: "Nueva Actividad",
		edit: "Editar Actividad",
		delete: "Eliminar Actividad",
		deleteConfirm: "¿Está seguro de que desea eliminar esta actividad?",
		date: "Fecha",
		startTime: "Hora",
		description: "Descripción",
		linkRitual: "Vincular a ritual",
		selectRitual: "Seleccionar ritual",
		reminder: "Enviar recordatorio por email",
		reminderDays: "Días antes",
		reminderHintSameDay: "El día de la actividad",
		reminderHint1Day: "1 día antes",
		reminderHintDays: "{days} días antes",
		reminderMessage: "Mensaje personalizado",
		reminderMessageHint: "Deje en blanco para usar la plantilla predeterminada",
		addToDay: "Agregar actividad",
		batchMode: "Múltiples días",
		batchDatesSelected: "{count} fecha(s) seleccionada(s)",
		linkFirstRitual: "Vincular al primer ritual de cada día, si existe",
	},
	messages: {
		created: "Grupo creado exitosamente",
		updated: "Grupo actualizado exitosamente",
		deleted: "Grupo eliminado exitosamente",
		memberAdded: "Miembro agregado exitosamente",
		memberRemoved: "Miembro eliminado exitosamente",
		assignmentCreated: "Actividad creada exitosamente",
		assignmentUpdated: "Actividad actualizada exitosamente",
		assignmentDeleted: "Actividad eliminada exitosamente",
		errorLoading: "Error al cargar datos",
	},
	stats: {
		total: "Total",
		active: "Activos",
		totalMembers: "Miembros",
	},
	validation: {
		nameRequired: "El nombre del grupo es obligatorio",
		nameMaxLength: "El nombre debe tener como máximo 150 caracteres",
	},
	activities: {
		tab: "Actividades",
		upcoming: "Próximas",
		past: "Anteriores",
		all: "Todas",
		linkedToRitual: "Vinculada a ritual",
		noActivities: "Ninguna actividad encontrada",
		noActivitiesUpcoming: "Ninguna actividad futura programada",
		noActivitiesPast: "Ninguna actividad anterior registrada",
		showMore: "Cargar más",
	},
	weekDays: {
		sun: "Dom",
		mon: "Lun",
		tue: "Mar",
		wed: "Mié",
		thu: "Jue",
		fri: "Vie",
		sat: "Sáb",
	},
};
